import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QltsUserController from "../../../../services/qlts/qlts-user-controller";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {getSchoolId, getSchoolYear} from "../../../../utils/authority";
import StudentController from "../../../../services/system/student/student-controller";
import GradeManager from "../../../../components/Grade";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import CLBRegisterController from "../../../../services/system/clb-register/clb-register-controller";

class ModalAddStudentToCLB extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clbId: -1,
            classRoomId: -1,
            listStudent: [],
            listClassRoom: [],
            studentName: "",
            studentId: -1,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({
                clbId: nextProps.item?.id,
                name: nextProps.item?.name,
                headTeacherId: nextProps.item?.principalId,
                numberSessions: nextProps.item?.numberSessions,
                price: nextProps.item?.price,
                surcharge: nextProps.item?.surcharge,
                schoolDay: nextProps.item?.schoolDay,
                startDay: nextProps.item?.startDay,
                endDay: nextProps.item?.endDay,
            })
        }
    }
    componentWillMount() {
        this.getListStudent()
    }
    addStudent = () => {
        if (this.state.studentId < 0){
            toast.warning("Vui lòng chọn học sinh!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                clbId: this.state.clbId,
                studentId: this.state.studentId,
                note: this.state.note,
                state: "ACTIVE",
                schoolId: parseInt(getSchoolId()),
                yearId: parseInt(getSchoolYear())
            }
            CLBRegisterController.create(payload, res => {
                if (res.success) {
                    toast.success("Thêm học sinh thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.warning(res.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }

    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: this.state.classRoomId,
            code: "",
            ethnic: "",
            fullName: this.state.studentName,
            gender: "",
            grade: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };
    render() {
        let {gradeId} = this.state
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm học sinh vào CLB</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Chọn khối</label>
                                    <GradeManager
                                        gradeId={gradeId}
                                        onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Chọn lớp</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.classRoomId}
                                        onChange={(e) => {
                                            this.state.classRoomId = e.target.value;
                                            this.setState({
                                                classRoomId: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="-1">Chọn lớp</option>
                                        {this.renderClassRoom()}
                                    </select>
                                </div>

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Chọn học sinh(<span  style={{color: "red",}}>*</span>)</label>
                                    <Autocomplete
                                        size="small"
                                        options={this.state.listStudent}
                                        getOptionLabel={option => option.fullName?option.fullName:""}
                                        style={{width: '100%'}}
                                        inputValue={this.state.studentName}
                                        renderInput={params => {
                                            return <TextField
                                                placeholder='Nhập tên học sinh'
                                                {...params}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        fontSize: 17,
                                                        backgroundColor: "#FFF",
                                                        paddingRight: 10,
                                                        paddingLeft: 10,
                                                        color: '#2e495c',
                                                        fontWeight: 500,
                                                        fontFamily: 'Montserrat'
                                                    }
                                                }}
                                                label=""
                                                variant="outlined"
                                                fullWidth
                                            />
                                        }}
                                        onInputChange={(event, val) => {
                                            if (event !== null){
                                                this.setState({
                                                    studentName: val
                                                })
                                                if (val === ""){
                                                    this.state.studentId = -1;
                                                }
                                            }
                                        }}
                                        onChange={(e, val) => {
                                            if (val?.id != undefined){
                                                this.setState({
                                                    studentId: val?.id,
                                                    studentName: val?.fullName,
                                                })
                                            }else {
                                                this.setState({
                                                    studentId: -1,
                                                    studentName: "",
                                                })
                                            }
                                            // this.getListPeopleInCharge()
                                        }}

                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Ghi chú</label>
                                    <input
                                        placeholder="Ghi chú"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.note}
                                        onChange={(event) => {
                                            this.setState({
                                                note: event.target.value
                                            })
                                        }}
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.addStudent()}
                                >
                                        <span className='justify-content-center'>
                                            Thêm
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalAddStudentToCLB
